import {useMutation} from '@tanstack/react-query'
import {useGetProductApiMethod} from 'api/useGetProductApiMethod'

export const useGetProductMutation = () => {
  const getProduct = useGetProductApiMethod()

  return useMutation({
    mutationFn: (productId: string) => getProduct(productId),
  })
}
